/**
 * ErrorLayout — minimal shell for error pages (404, 500).
 */

import { Outlet } from 'react-router-dom';
import { Container } from '@/components/ui';

export function ErrorLayout(): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Container maxWidth="md">
        <Outlet />
      </Container>
    </div>
  );
}
